import DraggableModal from 'components/organisms/draggableModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseForm from 'components/atoms/base-form';
import { NormalReadingsForm } from 'components/organisms/device-troubleshoot-templates/templates/deviceTroubleshootForm';
import FormItemWrapper from 'components/molecules/rpm-alert-assessment/formItemWrapper';

import s from '../../styles.module.scss';
import { useNormalReadings } from '../../hooks/use-normal-readings-modal';
import { useStoreModalValue } from '../../hooks/use-store-modal-value';

import type { INormalReadingsModalProps } from '../../types';
import type { FC } from 'react';

const NormalReadingsModal: FC<INormalReadingsModalProps> = ({
  isOpen,
  handleSubmit,
  closeModal,
  whichPerson,
  patientGuid,
  otherPerson,
}) => {
  const { t } = useTranslation();
  const { initialValues, onSaveForm } = useNormalReadings({
    closeModal,
    handleSubmit,
    whichPerson,
    otherPerson,
  });

  const type = 'min';

  type TInitialValues = typeof initialValues;
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<TInitialValues>({
      modalName: `normalReadings_${patientGuid}`,
    });

  const formik = useFormik({
    initialValues: parsedData ?? initialValues,
    onSubmit: (data) => {
      setModalValuesToStorage(data);
      onSaveForm(data);
    },
    validateOnChange: false,
  });

  const onSave = () => {
    formik.submitForm();
  };

  return (
    <>
      <DraggableModal
        isOpen={isOpen}
        toggle={closeModal}
        title={t('labels.RPMSpecialistTemplate')}
        onSave={onSave}
        dataCy="RPMSpecialistTemplate"
      >
        <BaseForm formik={formik}>
          <div className={s.wrapper}>
            {NormalReadingsForm.map((formItem, index) => {
              return (
                <FormItemWrapper
                  formik={formik}
                  index={index}
                  formItem={formItem}
                  type={type}
                  requiredSymptomFields={[]}
                />
              );
            })}
          </div>
        </BaseForm>
      </DraggableModal>
    </>
  );
};

export default NormalReadingsModal;
